<template>
    <div>
        <rkm-form
            ref="Form"
            show-legend
        >
            <rkm-row>
                <rkm-col cols="4">
                    <rkm-form-date-picker
                        range
                        :range-inline="false"
                        start-label="Período de"
                        end-label="Até"
                        :min-date="additionals.periodoMinDate"
                        :max-date="additionals.currentDate"
                        v-model="model.periodo"
                    />
                </rkm-col>

                <rkm-col cols="4">
                    <rkm-form-select
                        :options="form.unidades"
                        label="Unidade executante"
                        text-field="nomeFantasia"
                        v-model="model.unidadeId"
                        value-field="unidadeId"
                        :validations="validations.unidadeId"
                        show-default-option
                    />
                </rkm-col>

                <rkm-col cols="4">
                    <rkm-form-select
                        :options="form.profissionais"
                        label="Profissional executante"
                        show-default-option
                        text-field="profissionalNome"
                        v-model="model.profissionalId"
                        value-field="profissionalId"
                        :validations="validations.profissionalId"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="4">
                     <rkm-form-select
                        :options="form.grupoExames"
                        label="Grupo de exames"
                        show-default-option
                        text-field="grupoNome"
                        v-model="model.grupoExameId"
                        value-field="grupoExameId"
                        :validations="validations.grupoExameId"
                    />
                </rkm-col>

                <rkm-col cols="4">
                    <rkm-form-select
                        :options="form.exames"
                        label="Exames"
                        show-default-option
                        text-field="exameNome"
                        v-model="model.exameId"
                        value-field="exameId"
                    />
                </rkm-col>

                <rkm-col cols="4">
                    <rkm-form-select
                        label="Status"
                        textField="nome"
                        v-model="status"
                        valueField="id"
                        show-default-option
                        class="pt-0 mb-0"
                    >
                        <rkm-form-select-option :value="enums.statusFechamento.REALIZADO">
                            REALIZADO
                        </rkm-form-select-option>
                        <rkm-form-select-option :value="enums.statusFechamento.FALTOU">
                            FALTOU
                        </rkm-form-select-option>
                        <rkm-form-select-option :value="enums.statusFechamento.FALTA_MEDICA">
                            FALTA MÉDICA
                        </rkm-form-select-option>
                    </rkm-form-select>
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-input-autocomplete
                        :repository="repositories.paciente"
                        :search-fields="fields.paciente"
                        :text-field="(item) => item.cidadao.nome"
                        label="Paciente"
                        v-model="paciente"
                        uppercase
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-input
                        label="Número agendamento"
                        v-model="model.agendamentoNumero"
                        number
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-input
                        label="Número prontuário"
                        v-model="model.prontuario"
                        number
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-button
                        :label="false"
                        @click="$refs.Form.validate(search)"
                        color="primary"
                        class="float-left"
                    >
                        Buscar
                    </rkm-button>

                    <rkm-button
                        :label="false"
                        @click.stop="resetForm"
                        color="secondary"
                        class="mr-2 float-left"
                    >
                        Limpar
                    </rkm-button>
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <rkm-table
            :fields="fields.tables.itens"
            :items="itens"
            ref="Table"
            sort-by="data"
            hide-filters
        >
            <template v-slot:cell(status)="{ item }" >
                <rkm-form-select
                    :label="false"
                    textField="nome"
                    v-model="item.statusId"
                    valueField="id"
                    show-default-option
                    class="pt-0 mb-0"
                    @change="loadStatus(item.statusId)"
                >
                    <rkm-form-select-option
                        v-if="item.statusSalvo == enums.statusFechamento.REALIZADO
                            || item.statusSalvo == enums.statusFechamento.AGENDADO"
                        :value="enums.statusFechamento.REALIZADO"
                    >
                        REALIZADO
                    </rkm-form-select-option>
                    <rkm-form-select-option
                        v-if="item.statusSalvo == enums.statusFechamento.FALTOU
                            || item.statusSalvo == enums.statusFechamento.AGENDADO"
                        :value="enums.statusFechamento.FALTOU"

                    >
                        FALTOU
                    </rkm-form-select-option>
                    <rkm-form-select-option
                        v-if="item.statusSalvo == enums.statusFechamento.FALTA_MEDICA
                            || item.statusSalvo == enums.statusFechamento.AGENDADO"
                        :value="enums.statusFechamento.FALTA_MEDICA"

                    >
                        FALTA MÉDICA
                    </rkm-form-select-option>
                    <rkm-form-select-option
                        :value="enums.statusFechamento.AGENDADO"
                    >
                        AGENDADO
                    </rkm-form-select-option>
                </rkm-form-select>
            </template>

            <template v-slot:cell(actions)="{ item }">
                <rkm-button
                    :id="uniqueId('show-btn')"
                    @click="$refs.Modal.open(item)"
                    title="Detalhamento"
                    small
                    color="primary"
                >
                    <rkm-icon icon="search" />
                </rkm-button>
            </template>

            <template v-slot:custom-foot>
                <rkm-tr>
                    <rkm-th colspan="5" class="table-td">Realizado: {{verificaRealizado()}}</rkm-th>
                    <rkm-th colspan="5" class="table-td">Faltou: {{verificaFaltou()}}</rkm-th>
                </rkm-tr>
            </template>
        </rkm-table>

        <Modal
            ref="Modal"
            :data="data"
        />

    </div>
</template>

<script>
import { mapActions } from 'vuex'
import { repository, error, object, data, stringCase } from '@/mixins'

// Components.
import Modal from '@/components/exame-imagem/alteracao-exame-finalizado/components/Modal'

// Moment.
import moment from 'moment'

// Enuns.
import statusFechamento from '@/enums/exame-imagem/fechamento/status'

export default {
    components:{ Modal },
    computed: {
        fields() {

            return {
                tables: {
                    itens: [
                        { key: 'data', label: 'Data do pedido', class: 'col-max', sortable: true },
                        { key: 'agendamentoNumero', label: 'Agendamento', class: 'col-max', sortable: true },
                        { key: 'prontuario', label: 'Prontuário', class: 'col-max', sortable: true },
                        { key: 'exameNome', label: 'Exame', class: 'col-max', sortable: true },
                        { key: 'pacienteNome', label: 'Paciente', class: 'col-max', sortable: true },
                        { key: 'status', label: 'Status', class: 'col-mix', sortable: true },
                        { key: 'actions', label: 'Ações', class: 'col-min text-center'}
                    ]
                },
                paciente: [
                    { key: 'cidadao.nome', searchable: true },
                ],
            }
        },
        validations() {
            return {
                unidadeId: { required: true },
                profissionalId: { required: true },
                grupoExameId: { required: true },
            }
        },
    },
    created() {

        this.repositories = {
            alteracao: this.getConectaSusRepository('exameImagem.alteracaoExameFinalizado'),
            paciente: this.getConectaSusRepository('cadastro.sujeitoAtencao.paciente'),
        },
        this.load();
    },
    data() {
        return {
            selecionados: false,           
            agendamentoId: null,
            agendamentoNumero: null,
            exameId: null,
            medicoId: null,
            pacienteId: null,
            nomePaciente: '',            
            prontuario: null,
            statusId: null,
            unidadeId: null,         
            realizado: 0,
            faltou: 0,
            enums:{
                statusFechamento,
            },
            dataAtual: '',
            paciente: null,
            status: null,
            handleStatus: null,
            model: {
                periodo: {
                    start: null,
                    end: null,
                },
            },
            form: {},
            additionals: {},
            itens: [],
        }
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            this.repositories.alteracao.index()
                .then(({ data }) => {

                    this.form = data.form
                    this.model = data.model

                    this.setDefaultValues() 
              
                    this.loaded = true
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        setDefaultValues() {

            this.model.periodo.start = moment(this.form.dataAtual, 'DD/MM/YYYY').toDate()
            this.model.periodo.end = moment(this.form.dataAtual, 'DD/MM/YYYY').toDate()
        },
        getUnidades() {

            this.form.unidades = []
            this.form.profissionais = []
            this.form.grupoExames =[]

            if(!this.model.periodo.start && !this.model.periodo.end){
                return false
            }

            this.setLoading()

            const request = {
                dataInicio: moment(this.model.periodo.start).format('YYYY-MM-DD'),                
                dataFim: moment(this.model.periodo.end).format('YYYY-MM-DD'),                
            }

            this.repositories.alteracao.getUnidades(this.camelObjectKeysToSnakeRecursive(request))
                .then(({ data }) => {

                    this.form.unidades = data
                    this.model.unidadeId = null

                    if(data.length == 1) {
                        this.model.unidadeId = data[0].unidadeId
                    }                    
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())                
        },
        getProfissional() {

            this.form.profissionais = []
            this.form.grupoExames = []

            const request = {
                dataInicio: moment(this.model.periodo.start).format('YYYY-MM-DD'),                
                dataFim: moment(this.model.periodo.end).format('YYYY-MM-DD'),
                unidadeId: this.model.unidadeId,                
            }

            this.setLoading()
            this.repositories.alteracao.getProfissional(this.camelObjectKeysToSnakeRecursive(request))
                .then(({ data }) => {
                    this.form.profissionais = data
                    this.model.profissionalId = null

                    if(data.length == 1) {
                        this.model.profissionalId = data[0].profissionalId
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getGrupoExames() {       
            
            this.form.grupoExames = []

            const request = {
                dataInicio: moment(this.model.periodo.start).format('YYYY-MM-DD'),                
                dataFim: moment(this.model.periodo.end).format('YYYY-MM-DD'),
                unidadeId: this.model.unidadeId,                
                profissionalId: this.model.profissionalId,                
            }

            this.setLoading()
            this.repositories.alteracao.getGrupoExames(this.camelObjectKeysToSnakeRecursive(request))
                .then(({ data }) => {
                    this.form.grupoExames = data 
                    this.model.grupoExameId = null

                    if(data.length == 1) {
                        this.model.grupoExameId = data[0].grupoExameId
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getExames() {       
            
            const request = {
                dataInicio: moment(this.model.periodo.start).format('YYYY-MM-DD'),                
                dataFim: moment(this.model.periodo.end).format('YYYY-MM-DD'),
                unidadeId: this.model.unidadeId,                
                profissionalId: this.model.profissionalId,                
                grupoExameId: this.model.grupoExameId,                
            }

            this.setLoading()
            this.repositories.alteracao.getExames(this.camelObjectKeysToSnakeRecursive(request))
                .then(({ data }) => {

                    this.form.exames = data 
                    this.model.exameId = null

                    if(data.length == 1) {
                        this.model.exameId = data[0].exameId
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        search(){

            const request = {
                dataInicio: moment(this.model.periodo.start).format('YYYY-MM-DD'),                
                dataFim: moment(this.model.periodo.end).format('YYYY-MM-DD'),
                unidadeId: this.model.unidadeId,                
                profissionalId: this.model.profissionalId,                
                grupoExameId: this.model.grupoExameId,                
                exameId: this.model.exameId,                
                agendamentoNumero: this.model.agendamentoNumero,                
                prontuario: this.model.prontuario,                
                paciente: this.paciente ? this.paciente.id : null,                
                status: this.status ? this.status : 0,                
            }

            this.setLoading()
            this.repositories.alteracao.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {

                    this.itens = response.data  
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())           
        },
        resetForm() {

            this.model.unidadeId = null
            this.model.profissionalId = null
            this.model.grupoExameId = null
            this.model.exameId = null
            this.model.agendamentoNumero = null
            this.model.prontuario = null
            this.paciente = null
            this.status = null
            this.itens = []            

            this.$nextTick()
                .then(() => {

                    this.setDefaultValues()
                    this.$refs.Form.resetValidator()
                })
        },
        loadStatus(item){

            this.handleStatus = item
            this.$emit('handleStatusAgendado', this.handleStatus)
        },
        verificaRealizado(){

            return this.itens.filter(item => item.statusId === this.enums.statusFechamento.REALIZADO).length;
        },
        verificaFaltou(){

            return this.itens.filter(item => item.statusId === this.enums.statusFechamento.FALTOU).length;
        },
        save(){

            this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) return

                    if(this.handleStatus == this.enums.statusFechamento.AGENDADO){

                        const confirm = async () => {

                            this.setLoading()

                            this.repositories.alteracao.store(this.prepareData())
                            .then(({ data }) => {

                                this.showSaveNotification()
                                this.$emit('save', data)

                                this.resetForm()
                            })
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading())

                            return false
                        }

                        const cancel = async () => { }

                        const msg = `Ao substituir o status do exame para AGENDADO, ele retornará para a listagem` +
                            ` de <strong>fechamento de exames</strong>, caso haja laudo adicionado o mesmo será` +
                            ` perdido. Deseja continuar?`

                        this.showConfirmation(msg, confirm, cancel)

                        return false

                    } else {

                        this.setLoading()

                        this.repositories.alteracao.store(this.prepareData())
                            .then(({ data }) => {

                                this.showSaveNotification()
                                this.$emit('save', data)

                                this.resetForm()
                            })
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading())
                    }
                })
        },
        prepareData() {

            const itens = this.clone(this.itens)

            return this.camelObjectKeysToSnakeRecursive(itens)
        },
    },
    watch: {
        'model.periodo': {
            handler: function(newVal) {
                if (newVal.start || newVal.end) {
                    this.model.unidadeId = null
                    this.model.profissionalId = null
                    this.model.grupoExameId = null
                    this.model.exameId= null                
                    this.model.agendamentoNumero = null                
                    this.model.prontuario = null               
                    this.paciente = null               
                    this.status = null   
                    this.getUnidades()
                }
            },
            deep: true 
        },
        'model.unidadeId': function() {
            if(this.model.unidadeId) {
                this.model.profissionalId = null
                this.model.grupoExameId = null
                this.model.exameId= null                
                this.model.agendamentoNumero = null                
                this.model.prontuario = null               
                this.paciente = null               
                this.status = null  
                this.getProfissional()
            }
        },
        'model.profissionalId': function() {
            if(this.model.profissionalId) {
                this.model.exameId= null                
                this.model.agendamentoNumero = null                
                this.model.prontuario = null               
                this.paciente = null               
                this.status = null  
                this.getGrupoExames()
            }
        },
        'model.grupoExameId': function() {
            if(this.model.grupoExameId) {
                this.model.exameId= null                
                this.model.agendamentoNumero = null                
                this.model.prontuario = null               
                this.paciente = null               
                this.status = null  
                this.getExames()
            }
        },
    },
    validate() {

        return this.$refs.Form.validate()
    },
    mixins: [repository, error, object, data, stringCase],
    props: {
        data: { type: Object, required: true }
    },
}
</script>

<style scoped>
    .table-td {
        background: #e6e6e6;
        padding: 0 10px;
        height: 35px;
        border-top: 1px solid #ccc;
        font-weight: 600;
    }
    .table-border-top {
        border-top: 0;
        height: 30px;
        padding: 0;
    }
    .table-width {
        width: 100%;
    }
</style>